<template>
	<RotationLayout :rotation="rotation" :subtitle="`${trans('rotations.elections.title')}: ${rotation.election_period}`">
		<Empty v-if="rotationElections.data.length === 0"/>
		<template v-else>
			<Pagination :resource="rotationElections"/>
			<CardGrid>
				<Card v-for="rotationElection in rotationElections.data" :key="`rotation-election-${rotationElection.id}`" :title="transChoice('rotations.elections.candidates.count', rotationElection.candidates_count)">
					<template #badges>
						<Badge v-if="rotationElection.open" :color="Color.Green" active>{{ trans('general.open') }}</Badge>
						<Badge v-else :color="Color.Red">{{ trans('general.closed') }}</Badge>
						<div v-if="rotationElection.active" class="flex items-center gap-2 text-green-600 uppercase animate-pulse">
							<i class="fa-solid fa-circle"/>
							{{ trans('general.on_air') }}
						</div>
					</template>
					<template #footer>
						<Link :as="SecondaryButton" :color="Color.Blue" :href="route('association.representatives.rotations.elections.edit', {rotation: rotation.id, election: rotationElection.id})">
							<i class="fa-solid fa-edit mr-2"/>
							{{ trans('general.edit') }}
						</Link>
					</template>
				</Card>
			</CardGrid>
			<Pagination :resource="rotationElections"/>
		</template>
	</RotationLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {Link} from '@inertiajs/vue3'
import {Color} from '@/Types/Enums/Color'
import Empty from '@/Components/UI/Empty.vue'
import {defineProps, type Ref, ref} from 'vue'
import Card from '@/Components/UI/Cards/Card.vue'
import {trans, transChoice} from 'laravel-vue-i18n'
import Badge from '@/Components/UI/Badges/Badge.vue'
import Pagination from '@/Components/UI/Pagination.vue'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import RotationLayout from '@/Layouts/RotationLayout.vue'
import {type Rotation} from '@/Types/Periods/Rotations/Rotation'
import {type PaginatedModel} from '@/Types/Pagination/PaginatedModel'
import {type RotationElection} from '@/Types/Elections/RotationElection'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'

const props = defineProps<{
	rotation:Rotation,
	rotationElections:PaginatedModel<RotationElection>,
}>()

const rotationElections:Ref<PaginatedModel<RotationElection>> = ref(props.rotationElections)
</script>